import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class CompraService {
	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
	}

	getAll(queryString: String = "") {
		let url = this.host_api + '/compras' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getCuentasGenerales(queryString: String = ""){
		let url = this.host_api + '/compras/generales' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getTotalesCuentasGenerales(queryString: String = ""){
		let url = this.host_api + '/compras/generales_totales' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getBySuscripcion(queryString: String = "") {
		let url = this.host_api + '/compras/suscripcion' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

		

	getByComprasNetas(queryString: String = "") {
		let url = this.host_api + '/compras/netas' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getComprasVsVentas(queryString: String = "") {
		let url = this.host_api + '/compras/comprasvsventas' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}


	getAllComprasByFilter(queryString: String = ""){
		let url = this.host_api + '/compras/Allfilter' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getAllByNotas(queryString: String = ""){
		let url = this.host_api + '/compras/AllByNotas' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}


	getAllByFilter(queryString: String = ""){
		let url = this.host_api + '/compras/filter' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getDataKardex(producto_id,qs: String = ""){
		let url = this.host_api + '/compras/kardex/' + producto_id+qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getDataATS(queryString: String = ""){
		let url = this.host_api + '/compras/ats' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getById(id, qs: String = "") {
		let url = this.host_api + '/compras/' + id + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	save(Compra,qs="") {
		let url = this.host_api + '/compras'+qs;
		let params = Compra;//JSON.stringify(categoria);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	update(Compra) {
		let url = this.host_api + '/compras/' + Compra.id;
		let params = JSON.stringify(Compra);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	delete(id) {
		var url = this.host_api + '/compras/' + id + '/del';
		let params = {usuario_id: this.ss.getData('usuario_id')};
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	anular(Compra) {
		let url = this.host_api + '/compras/anulacion/' + Compra.id;
		let params = JSON.stringify(Compra);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/compra.service.ts